import React, { useReducer } from 'react'
import GiftContext from './giftContext'
import GiftReducer from './giftReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
    GET_ALL_GIFT_CARDS,
    GET_SINGLE_GIFT_CARD,
    GET_ALL_USED_GIFT_CARDS,
} from './giftTypes'

const GiftState = (props) => {
    const initialState = {
        responseStatus: null,
        search_allgiftcards: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        search_allused_giftcards: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        search_single_giftcard: {
            record: {},
        },
    }

    const [state, dispatch] = useReducer(GiftReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllGiftCards = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllGiftCards', formData, '', 'giftcard'),
            ])
            const from = 'getAllGiftCards'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_GIFT_CARDS,
                    payload: {
                        records: res.data.data.responseData.record.length
                            ? res.data.data.responseData.record
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('getAllGiftCards')
        }
    }

    const getSingleGiftCard = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getSingleGiftCard', formData, '', 'giftcard'),
            ])
            const from = 'getSingleGiftCard'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_GIFT_CARD,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const giftCardAction = async (formData, from = 'giftCardAction') => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'giftCardAction', formData, '', 'giftcard'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllUsedGiftCards = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllUsedGiftCards',
                    formData,
                    '',
                    'giftcard'
                ),
            ])
            const from = 'getAllUsedGiftCards'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_USED_GIFT_CARDS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('getAllCoupons')
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <GiftContext.Provider
            value={{
                responseStatus: state.responseStatus,
                search_allgiftcards: state.search_allgiftcards,
                search_single_giftcard: state.search_single_giftcard,
                search_allused_giftcards: state.search_allused_giftcards,
                getSingleGiftCard,
                getAllUsedGiftCards,
                getAllGiftCards,
                giftCardAction,
                clearResponse,
            }}
        >
            {props.children}
        </GiftContext.Provider>
    )
}

export default GiftState
